import { render, staticRenderFns } from "./PFLoanBankDataForm.vue?vue&type=template&id=5ac8b844"
import script from "./PFLoanBankDataForm.vue?vue&type=script&lang=js"
export * from "./PFLoanBankDataForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports